export default function linkText(client, isLoginLink = true) {
    let text = `View in ${client.providerName}`;

    if (client.provider === 'quickbooks' && isLoginLink) {
        text = `Link to ${client.providerName}`;
    }

    return text;
}
